<template>
  <div
    v-editable="blok"
    class="ModalVideoPlayerBlock layout-container"
    :class="[desktopWidth('md'), blockPaddingTop('md'), blockPaddingBottom('md')]"
  >
    <div
      :class="{
        'desk:flex desk:gap-40 items-center justify-center': blok.design === 'text-right' || blok.design === 'text-left'
      }"
    >
      <div
        class="relative"
        :class="{
          'basis-1/2': blok.design === 'text-right' || blok.design === 'text-left',
          'order-2': blok.design === 'text-left'
        }"
      >
        <img
          v-if="blok.youtubeId !== ''"
          :src="previewImg"
          class="w-full cursor-pointer"
        >
        <div
          class="absolute top-0 left-0 w-full h-full flex items-center justify-center"
          @click="modalOpen = true"
        >
          <div class="bg-bg-inverse h-48 w-48 flex items-center justify-center">
            <img
              src="/icons/play-filled.svg"
              class="h-24 w-24"
            >
          </div>
        </div>
      </div>
      <div
        :class="{
          'basis-1/2': blok.design === 'text-right' || blok.design === 'text-left',
          'order-1': blok.design === 'text-left'
        }"
      >
        <div
          class="type-headline-xl"
          :class="{
            'mt-16 desk:mt-20': blok.design === 'full-width'
          }"
        >
          {{ blok.headline }}
        </div>
        <div class="wysiwyg mt-12">
          <ExtendedWysiwyg :content="blok.text" />
        </div>
      </div>
    </div>
    <Teleport to="body">
      <div
        v-if="modalOpen"
        class="modalBg modalHeight w-full flex items-center justify-center "
        @click="modalOpen = false"
      >
        <div
          class="bg-lightest w-full desk:max-w-[80vw] p-8 desk:p-32 shadow-xl"
        >
          <div class="w-full aspect-wide">
            <iframe
              :src="`https://www.youtube.com/embed/${blok.youtubeId}`"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
              class="w-full h-full"
            />
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script setup lang="ts">
import { StoryBlokPropBase } from '~/constants/types/storyblok';
import useVisualAppearancePlugin from '~/composeables/useVisualAppearancePlugin';
import { ISbRichtext } from 'storyblok-js-client';

type Props = StoryBlokPropBase & {
  youtubeId?: string
  previewImage: '0' | '1' | '2' | '3',
  headline: string,
  text: ISbRichtext,
  design: 'full-width' | 'text-left' | 'text-right',
}

const modalOpen = ref(false);

const props = defineProps<{
  blok: Props,
}>();

const { desktopWidth, blockPaddingTop, blockPaddingBottom } = useVisualAppearancePlugin(props);

const previewImg = computed(()=> {
  if (props.blok.previewImage === '0') {
    return `https://img.youtube.com/vi/${props.blok.youtubeId}/maxresdefault.jpg`;
  }
  return `https://img.youtube.com/vi/${props.blok.youtubeId}/maxres${props.blok.previewImage}.jpg`;
});

</script>

<style scoped lang="postcss">
</style>
